"use client";
import { Button } from "react-bootstrap";
import { baseUrl } from "utils/constants";

export default function BlankPage() {
  return (
	
		<div>
			<div className="cpr_content">
				<div className="cpr_content_inner">
						<div className="cpr_content_bottom">


							{/* placeholder for middle content */}
							{/* chat bubbles and cards */}
							<div className="user_bubble">
								<div className="user_bubble__img" style={{backgroundImage: 'url("https://pics.harstatic.com/agent/312961.jpg?ts=2020-03-01T19:56:00")' }} ></div>
								<div className="user_bubble__text">
									What is the asking price for the property?
								</div>
							</div>
						
							<div className="chatbot_bubble">
								<div className="chatbot_bubble__img"><img src="https://content.harstatic.com/media/icons/common/HAR_AI_Logo.svg" /></div>
								<div className="chatbot_bubble__text">
									The asking price is $425,000.
								</div>
							</div>

							<div className="user_bubble">
								<div className="user_bubble__img" style={{backgroundImage: 'url("https://pics.harstatic.com/agent/312961.jpg?ts=2020-03-01T19:56:00")' }} ></div>
								<div className="user_bubble__text">
									How long has the property been on the market?
								</div>
							</div>
						
							<div className="chatbot_bubble">
								<div className="chatbot_bubble__img"><img src="https://content.harstatic.com/media/icons/common/HAR_AI_Logo.svg" /></div>
								<div className="chatbot_bubble__text">
								The property has been on the market for 1 day.
								</div>
							</div>

							<div className="user_bubble">
								<div className="user_bubble__img" style={{backgroundImage: 'url("https://pics.harstatic.com/agent/312961.jpg?ts=2020-03-01T19:56:00")' }} ></div>
								<div className="user_bubble__text">
								What is the address of the property?
								</div>
							</div>

							<div className="chatbot_bubble">
								<div className="chatbot_bubble__img"><img src="https://content.harstatic.com/media/icons/common/HAR_AI_Logo.svg" /></div>
								<div className="chatbot_bubble__text">
								15763 Tanya Cir, Houston, TX 77079.
								</div>
							</div>

							<div className="richcontent_bubble left_margin ">
								{/* card--mini v2 */}
								<div className="cardv2--mini cursor--pointer " style={{maxWidth:'370px'}}>
									<div className="cardv2--mini__content">
									<div className="cardv2--mini__content__body">
										<a href="https://www.har.com/homedetail/120-carnarvon-dr-houston-tx-77024/3144594">
										{/* card img */}
										<div className="cardv2--mini__content__body__image">
											<div
											className="cardv2--mini__content__body__image__img bg__bottom"
											style={{
												backgroundImage:
												"url(https://photos.harstatic.com/297961427/hr/img-1.jpeg?ts=2024-09-04T16:49:07.777)"
											}}
											/>
										</div>
										{/* / card img */}
										</a>
										{/* card header */}
										{/* card details */}
										<div className="cardv2--mini__content__body__details">
										<div>
											<div className="cardv2--mini__content__body__details_address">
											<div className="cardv2--mini__content__body__details_address_left">
												<div className="cardv2--mini__content__body__details_price">
												$425,000
												</div>
											</div>
											<div className="cardv2--mini__content__body__details_address_right">
												<div className="label label--forsale">Active</div>
											</div>
											</div>
											<div className="">
											<div className="cardv2--mini__content__body__details_address_left_add">
												15763 Tanya Cir
												<br />
												Houston, TX 77079
											</div>
											<div className="cardv2--mini__content__body__details_features">
												<ul>
												<li>4 - 5 beds</li>
												<li>3 baths</li>
												<li>3,808 sqft</li>
												</ul>
											</div>
											<div className="cardv2--mini__content__body__details_dayson">
												<div className="circle_nimber">1</div> Days on HAR
											</div>
											</div>
										</div>
										</div>
										{/* / card details */}
									</div>
									{/* / card body */}
									</div>
									{/* / card content */}
								</div>
								{/* / card--mini v2 */}
							</div>
											
							<div className="user_bubble">
								<div className="user_bubble__img" style={{backgroundImage: 'url("https://pics.harstatic.com/agent/312961.jpg?ts=2020-03-01T19:56:00")' }} ></div>
								<div className="user_bubble__text">
								How many bedrooms does the property have?
								</div>
							</div>
						
							<div className="chatbot_bubble">
								<div className="chatbot_bubble__img"><img src="https://content.harstatic.com/media/icons/common/HAR_AI_Logo.svg" /></div>
								<div className="chatbot_bubble__text">
								The property has 4 bedrooms, with a potential for a 5th bedroom in the flex room.
								</div>
							</div>
							
							<div className="user_bubble">
								<div className="user_bubble__img" style={{backgroundImage: 'url("https://pics.harstatic.com/agent/312961.jpg?ts=2020-03-01T19:56:00")' }} ></div>
								<div className="user_bubble__text">
								How many bathrooms are in the property?
								</div>
							</div>
						
							<div className="chatbot_bubble">
								<div className="chatbot_bubble__img"><img src="https://content.harstatic.com/media/icons/common/HAR_AI_Logo.svg" /></div>
								<div className="chatbot_bubble__text">
								The property has 3 full bathrooms and 1 half bathroom.
								</div>
							</div>
							{/*						
							<div className="user_bubble">
								<div className="user_bubble__img" style={{backgroundImage: 'url("https://pics.harstatic.com/agent/312961.jpg?ts=2020-03-01T19:56:00")' }} ></div>
								<div className="user_bubble__text">
								What is the square footage of the house?
								</div>
							</div>
						
							<div className="chatbot_bubble">
								<div className="chatbot_bubble__img"><img src="https://content.harstatic.com/media/icons/common/HAR_AI_Logo.svg" /></div>
								<div className="chatbot_bubble__text">
								The house is 3,808 square feet.
								</div>
							</div>
							*/}

							{/* chat bubbles and cards ended */}
						</div>
				</div>
			</div>
			
			<div className="input_bar">
				

				<div className="input_main_container">
					<div className="input_text_bar">
						<input type="text" className="input_text_bar_text form-control" />
						<button type="button" className="btn btn--primary btn--large input_text_bar_btn d-flex align-items-center" disabled><img src="https://content.harstatic.com/media/icons/copilot/ai_node_arrow.svg" /></button>
					</div>
					<div className="footer_disclaimer font_size--small_extra color_auxiliary text-center pt-2 d-md-block d-none">
						HAR.AI may produce inaccurate information about listings, market, or facts. 
						<a className="color_auxiliary" href="#">HAR.AI Privacy Notice</a>
					</div>
					<div className="footer_disclaimer font_size--small_extra_extra color_auxiliary text-center pt-2 d-md-none d-block">
						HAR.AI may provide inaccurate details. Check <a className="color_auxiliary" href="#">HAR.AI Privacy Notice</a>
					</div>
				</div>
			</div>
		</div>
  );
}
